import DocumentPage from "../../../invoice/DocumentPage";
import { deliveryNoteConfig } from "./config";

const DeliveryNote = () => <DocumentPage config={deliveryNoteConfig} />;

export default DeliveryNote;
